import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

// components

export default function UpdateStatus({ showModal, setShowModal, setItems, items, ordersCode,data ,datasSearch}) {
    const [datas, setDatas] = useState("");
    const [status, setStatus] = useState("");
    const [showStatus, setShowStatus] = useState(false);
    const { user } = useSelector(state => state.user)
    let item = datasSearch ?  datasSearch?.find(x => x.ordersCode === ordersCode) : data ? data?.find(x => x.ordersCode === ordersCode) : ""
    // item.status = datas.status

    // console.log(status);
    // console.log(datas);
    // console.log(showStatus);
    
    useEffect(() => {
        axios.post(`http://${process.env.REACT_APP_API_URL}/orders/search`, { ordersCode: ordersCode }, {
            headers: {
                Bearer: localStorage.getItem('token')
            }
        }).then( (response) => {
            if (response.status === 200) {
                setDatas(response.data.orders ? response.data.orders : response.data);
                setStatus({ status: response?.data?.orders?.status })
            }
        }
        ).catch((error) => {
            if (error.response.data.status === 401) {
                window.location.href = "/auth/login";
            }
            console.log(error);
        });

    }, [ordersCode,showStatus])

    useEffect(() => {
        if (status.status === "Waiting Shipping" ||status.status === "Shipping" || status.status === "Waiting Return" || status.status === "Completed" || status.status === "Claim" || status.status === "Return" || status.status === "Lost") {
            setShowStatus(true)
        } else {
            setShowStatus(false)
        }
    }, [status.status])

    // console.log(showStatus, status.status);

    // const handleData = (e) => {
    //     setDatas({ ...datas, [e.target.name]: e.target.value })
    // }
    useEffect(() => {
        if (datas.status === "Shipping") {
            setDatas({ ...datas, trackingNum: datas.trackingNumber })
        }
    }, [datas.trackingNumber])

    const handleData = (e) => {
        setDatas({ ...datas, [e.target.name]: e.target.value })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log(datas);
        // axios.post(`http://${process.env.REACT_APP_API_URL}/orders/save-status`, { ...datas, ordersCode: ordersCode }, {
        //     headers: {
        //         Bearer: localStorage.getItem('token')
        //     }
        // }).then((response) => {
        //     if (response.status === 200) {
        //         // console.log(response);
        //         Swal.fire({
        //             icon: 'success',
        //             title: 'อัพเดทสถานะสำเร็จ',
        //             showConfirmButton: false,
        //             timer: 1500
        //         }).then(() => {
        //             window.location.reload();
        //             setShowModal(false);
        //         }
        //         )
        //     }
        // }
        // ).catch((error) => {
        //     if (error.response.data.status === 401) {
        //         window.location.href = "/auth/login";
        //     }
        //     console.log(error);
        // });

        Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Update"
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(`http://${process.env.REACT_APP_API_URL}/orders/save-status`, { ...datas, ordersCode: ordersCode }, {
                    headers: {
                        Bearer: localStorage.getItem('token')
                    }
                }).then((response) => {
                    console.log(response);
                    if (response.status === 200) {
                        item.status = datas.status
                        item.trackingNumber = datas.trackingNum

                        Swal.fire({
                            title: "success!",
                            icon: "success",
                            timer: 1500,
                            showConfirmButton: false,


                        }).then(() => {
                            // window.location.reload();
                            setShowModal(false);
                            setStatus({ status:datas.status })
                        }
                        );

                    }
                }
                ).catch((error) => {
                    if (error.response.data.status === 401) {
                        window.location.href = "/auth/login";
                    }
                    //  console.log(error);
                    console.log(error.response.data.message);
                    
                    Swal.fire({
                        title: error.response.data.message,
                        icon: "error",
                        timer: 2000,
                    });
                });
            }
        });
    }

    return (
        <>
            {showModal && <>
                {datas && <div
                    className="absolute inset-0 z-50 flex items-center justify-center w-full h-full overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
                    style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
                // className="fixed inset-0 flex items-center justify-center w-full h-full overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
                // onClick={() => setShowModal(false)}
                >
                    <div className="relative mx-auto my-6" style={{ width: "40%" }}>
                        {/*content*/}
                        <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
                            {/*header*/}
                            <div className="flex items-start justify-between p-5 border-b border-solid rounded-t border-blueGray-200">
                                <h3 className="text-3xl font-semibold">
                                    อัพเดทสถานะ  {ordersCode}
                                </h3>


                                <button
                                    className="float-right p-1 text-3xl font-semibold leading-none text-black bg-transparent border-0 outline-none opacity-5 focus:outline-none"
                                    onClick={() => setShowModal(false)}
                                >
                                    <span className="block w-6 h-6 text-2xl text-black bg-transparent outline-none opacity-5 focus:outline-none">
                                        ×
                                    </span>
                                </button>
                            </div>
                            {/*body*/}
                            <div className="px-3 mb-3 md:mb-0 " style={{ width: "300px", padding: "10px" }}>
                                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                                    สถานะ
                                </label>
                                {showStatus
                                    ?
                                    <select name="status" id="status" className="rounded" onChange={handleData} value={datas.status} style={{ width: "275px", height: "50px" }} >
                                        <option value="" disabled selected>Choose</option>
                                        <option value="Waiting Shipping" >Waiting Shipping</option>
                                        <option value="Shipping" >Shipping</option>
                                        <option value="Waiting Return" >Waiting Return</option>
                                        {user.role == 99 && <option value="Completed" >Completed</option>}
                                        <option value="Claim" >Claim</option>
                                        <option value="Return" >Return</option>
                                        <option value="Lost" >Lost</option>
                                    </select>
                                    :
                                    <select name="status" id="status" className="rounded" onChange={handleData} value={datas.status} style={{ width: "275px", height: "50px" }} >
                                        <option value="" disabled selected>Choose</option>
                                        <option value="Opened" >Opened</option>
                                        <option value="Cancelled" >Cancelled</option>
                                        <option value="Waiting Shipping" >Waiting Shipping</option>
                                        <option value="Shipping" >Shipping</option>
                                        <option value="Waiting Return" >Waiting Return</option>
                                        {user.role == 99 && <option value="Completed" >Completed</option>}
                                        <option value="Claim" >Claim</option>
                                        <option value="Return" >Return</option>
                                        <option value="Lost" >Lost</option>
                                    </select>}
                                {/* {!datas.status && <p className="mt-3 text-xs italic text-red-500">โปรดเลือก วิธีการชำระเงิน </p>} */}
                            </div>

                            {datas.status === "Shipping" && <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                                    หมายเลขติดตาม
                                </label>
                                <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                                    id="trackingNum" name="trackingNum" type="text" onChange={handleData} value={datas.trackingNum} />
                                {!datas.trackingNum && <p className="text-xs italic text-red-500">โปรดกรอก หมายเลขติดตาม</p>}
                            </div>}
                            <div className="w-full px-3 mb-3 md:mb-0">
                                <button
                                    className={"px-3 py-3 m-1 mr-1 text-xs font-bold text-white uppercase transition-all duration-150 ease-linear bg-indigo-500 rounded outline-none active:bg-indigo-600 focus:outline-none"}
                                    type="button"
                                    disabled={!datas.status || (datas.status === "Shipping" && !datas.trackingNum)}
                                    onClick={handleSubmit}
                                    style={{ backgroundColor: !datas.status || (datas.status === "Shipping" && !datas.trackingNum) && "gray" }}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>}
            </>}
        </>
    );
}
